/* Magazin Single – Table of Contents.
   Baut aus den H2/H3 des Artikelinhalts eine verschachtelte, sticky-fähige
   Inhaltsangabe mit Scroll-Spy. Keine Abhängigkeiten. */
(function () {
  'use strict';

  function slugify(text, used) {
    var base = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[\s\u00a0]+/g, '-')
      .replace(/[^a-z0-9\u00e4\u00f6\u00fc\u00df-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    if (!base) base = 'abschnitt';
    var id = base;
    var i = 2;
    while (used[id]) {
      id = base + '-' + i;
      i++;
    }
    used[id] = true;
    return id;
  }

  function initSection(section) {
    var toc = section.querySelector('[data-mag-toc]');
    var list = section.querySelector('[data-mag-toc-list]');
    var content = section.querySelector('[data-mag-content]');
    if (!toc || !list || !content) return;

    var allHeadings = content.querySelectorAll('h2, h3');
    // Überschriften aus der Newsletter-Sidebar nicht ins Inhaltsverzeichnis übernehmen.
    var headings = Array.prototype.filter.call(allHeadings, function (heading) {
      return !heading.closest('#newsletter-sidebar');
    });
    if (!headings.length) {
      toc.hidden = true;
      return;
    }

    var used = {};
    var links = {};
    var listFrag = document.createDocumentFragment();

    Array.prototype.forEach.call(headings, function (heading) {
      var text = heading.textContent.trim();
      if (!text) return;

      if (!heading.id) {
        heading.id = slugify(text, used);
      } else {
        used[heading.id] = true;
      }

      var isSub = heading.tagName.toLowerCase() === 'h3';
      var li = document.createElement('li');
      li.className = 'mag-toc__item' + (isSub ? ' mag-toc__item--sub' : '');

      var a = document.createElement('a');
      a.className = 'mag-toc__link';
      a.href = '#' + heading.id;
      a.textContent = text;
      a.setAttribute('data-target', heading.id);

      li.appendChild(a);
      listFrag.appendChild(li);
      links[heading.id] = a;
    });

    list.appendChild(listFrag);

    setupToggle(toc);
    setupScrollSpy(headings, links, toc);
  }

  // Desktop: TOC immer offen. Mobile: standardmäßig zugeklappt, manuell aufklappbar.
  function setupToggle(toc) {
    if (!toc || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 1000px)');

    function apply() {
      if (mq.matches) {
        toc.open = true;
      } else {
        toc.open = false;
      }
    }

    apply();
    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else if (mq.addListener) {
      mq.addListener(apply);
    }
  }

  function scrollLinkIntoView(container, link) {
    if (!container || !link) return;
    // Nur wenn das Inhaltsverzeichnis intern scrollbar ist (Desktop, viele Einträge)
    if (container.scrollHeight <= container.clientHeight + 1) return;

    var linkRect = link.getBoundingClientRect();
    var boxRect = container.getBoundingClientRect();
    var pad = 12;

    if (linkRect.top < boxRect.top + pad) {
      container.scrollTop += linkRect.top - boxRect.top - pad;
    } else if (linkRect.bottom > boxRect.bottom - pad) {
      container.scrollTop += linkRect.bottom - boxRect.bottom + pad;
    }
  }

  function setupScrollSpy(headings, links, toc) {
    if (!('IntersectionObserver' in window)) return;

    var visible = {};
    var current = null;

    function setActive(id) {
      if (id === current) return;
      if (current && links[current]) links[current].classList.remove('is-active');
      if (id && links[id]) {
        links[id].classList.add('is-active');
        scrollLinkIntoView(toc, links[id]);
      }
      current = id;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible[entry.target.id] = true;
          } else {
            delete visible[entry.target.id];
          }
        });

        var topMost = null;
        var topY = Infinity;
        Array.prototype.forEach.call(headings, function (h) {
          if (visible[h.id]) {
            var y = h.getBoundingClientRect().top;
            if (y < topY) {
              topY = y;
              topMost = h.id;
            }
          }
        });

        if (topMost) setActive(topMost);
      },
      {
        rootMargin: '-10% 0px -70% 0px',
        threshold: 0
      }
    );

    Array.prototype.forEach.call(headings, function (h) {
      observer.observe(h);
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-mag-single]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
